import { pdf } from '@react-pdf/renderer';
import { useSnackbar } from 'notistack';
import React from 'react';
import useFetch from 'use-http';
import { useGlobalSelector } from 'stores';
import { downloadBlob } from 'utils/export';
import { getBase64Image } from 'utils/utilities';
import { SintesiCdAFrane } from '../pdf';

const useExportCdaFrane = ({ id, intCode, setExportSuccess }) => {
  const { get } = useFetch();
  const { enqueueSnackbar } = useSnackbar();
  const { showLoader, hideLoader } = useGlobalSelector();
  const { get: exportLambdaUrl } = useFetch(
    process.env.REACT_APP_EXPORT_LAMBDA_URL
  );

  const date = new Date();
  const currentDate = date.toLocaleDateString().replaceAll('/', '-');
  const currentTime = date.toLocaleTimeString('it-IT').replaceAll(':', '-');

  const pdfFraneName = `${intCode} - Sintesi CdA Frane - ${currentDate} ${currentTime}`;

  const exportCdAFrane = async formData => {
    try {
      showLoader();
      //const cdaFrane = await get(`exports/${id}/landslide-cda`);
      const cdaFrane = await exportLambdaUrl(`/?bridgeId=${id}&type=31`);
      if (cdaFrane) {
        setExportSuccess(true);
      } else {
        setExportSuccess(false);
      }

      const fotoBase64Satellitare = await getBase64Image(
        cdaFrane.satellitareFotoAereeAttuale
      );
      //const fotoBase64Copertina = await getBase64Image(cdaFrane.fotoCopertina);
      const fotoBase64Copertina = cdaFrane.fotoCopertina;

      const fotoBase64StralcioMappa = await getBase64Image(
        cdaFrane.stralcioMappaPericolositàFranePAI
      );

      const _cdaFrane = {
        ...cdaFrane,
        satellitareFotoAereeAttuale: fotoBase64Satellitare,
        fotoCopertina: fotoBase64Copertina,
        stralcioMappaPericolositàFranePAI: fotoBase64StralcioMappa,
      };

      const PDFCdAFrane = await pdf(
        <SintesiCdAFrane pdfData={_cdaFrane} formData={formData} />
      ).toBlob();
      downloadBlob(PDFCdAFrane, pdfFraneName);

      return PDFCdAFrane;
    } catch (error) {
      console.log(error);
      return enqueueSnackbar(`Impossibile eseguire l'esportazione`, {
        variant: 'error',
      });
    } finally {
      hideLoader();
    }
  };
  return { exportCdAFrane, pdfFraneName };
};

export default useExportCdaFrane;
